import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../assets/images/logo.png';
export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: '#f7f7f7', mt: 8, py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display:'flex', alignItems: 'center', mb: 2 }}>
              <Box component="img" src={Logo} alt="Rite HVAC" sx={{ height: 150, mr: 1 }} />
            </Box>
            <Typography variant="body2" color="text.secondary">
              123 HVAC Drive, Bloomington, IN 47401<br/>
              +1 (812) 555-0168 · info@ritehvacservices.com
            </Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography variant="h6" sx={{ mb: 1 }}>Sitemap</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Link component={RouterLink} to="/">Home</Link>
              <Link component={RouterLink} to="/about">About</Link>
              <Link component={RouterLink} to="/services">Services</Link>
              <Link component={RouterLink} to="/blog">Blog</Link>
              {/* <Link component={RouterLink} to="/case-studies">Case Studies</Link> */}
              <Link component={RouterLink} to="/faq">FAQ</Link>
              <Link component={RouterLink} to="/contact">Contact</Link>
              <Link component={RouterLink} to="/book">Book</Link>
              <Link component={RouterLink} to="/privacy">Privacy</Link>
              <Link component={RouterLink} to="/terms">Terms</Link>
            </Box>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography variant="h6" sx={{ mb: 1 }}>Hours</Typography>
            <Typography variant="body2" color="text.secondary">
              24/7 Emergency Service<br/>Mon–Sun: 12:00 AM – 11:59 PM
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3 }}>
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} Rite HVAC Services — All rights reserved.
          </Typography>
        </Box>
        {/* LocalBusiness schema */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify({
          "@context":"https://schema.org",
          "@type":"LocalBusiness",
          "name":"Rite HVAC Services",
          "telephone":"+1-812-555-0168",
          "email":"info@ritehvacservices.com",
          "address":{
            "@type":"PostalAddress",
            "streetAddress":"123 HVAC Drive",
            "addressLocality":"Bloomington","addressRegion":"IN","postalCode":"47401","addressCountry":"US"
          },
          "areaServed":["Bloomington IN","Ellettsville","Bedford","Martinsville","Spencer"]
        })}}/>
      </Container>
    </Box>
  );
}
